module.exports = __webpack_public_path__ + "img/landing-page.eecfa5bb.png";